import React from "react";
import { useStickyScroll } from "hooks/useStickyScroll";
import StickyBanner from "components/sticky-banner/StickyBanner";
import { useProductConfig } from "context/ProductContext";

interface ValuePropsProps {
    className?: string;
}

const ValueProps = ({ className = "" }: ValuePropsProps) => {
    const { elementRef, isSticky } = useStickyScroll({ offset: 0 });
    const config = useProductConfig();

    return (
        <>
            <div ref={elementRef} className={`w-full ${!isSticky ? "bg-error px-4 py-6 gap-4" : ""} ${className}`}>
                {!isSticky && (
                    <div className="flex text-primary-content justify-between text-center tablet:flex-row flex-col font-sans font-bold leading-7 max-w-[1200px] mx-auto">
                        <div className="text-lg">{config.bannerTexts.left}</div>
                        <div className="text-lg">{config.bannerTexts.center}</div>
                        <div className="text-lg">{config.bannerTexts.right}</div>
                    </div>
                )}
            </div>
            {isSticky && <StickyBanner />}
        </>
    );
};

export default ValueProps;
